import React, { useState } from "react";
import { Modal,Spinner } from "react-bootstrap";
import {
  FaUsers,
} from "react-icons/fa";
import { formatToIndianNumber, toInitials } from "../../utilities";
import { bulkEmployeePaidSalary } from "../../services/salaryService";
import { toast } from "react-toastify";

const PaymentModal = ({
  isOpen,
  onClose,
  employee,
  employees = [],
  onPaymentSuccess,
  isBulkPayment = false,
}) => {
  const [loading,setLoading]=useState(false)
  if (!isBulkPayment && !employee) return null;
  if (isBulkPayment && employees.length === 0) return null;

  const handlePayment = () => {
    if(isBulkPayment){
      handleBulkEmployee()
    }
    else{
      handleSingleEmployee()
    }
  };
  
  const handleSingleEmployee=()=>{
    setLoading(true)
     bulkEmployeePaidSalary({ids:[employee?.id||''],payment_status:'PAID'})
    .then((res)=>{
      toast.success('Paid Successfully')
      onPaymentSuccess()
    })
    .catch((err)=>{
      toast.error(err?.response?.data?.message||err?.response?.data?.error||'Try again later')
    })
    .finally(()=>setLoading(false))
  }

   const handleBulkEmployee=()=>{
    const idArray=employees?.map((item)=>item?.id)
    setLoading(true)
    bulkEmployeePaidSalary({ids:idArray||[],payment_status:'PAID'})
    .then((res)=>{
      toast.success('Paid Successfully')
      onPaymentSuccess()
    })
    .catch((err)=>{
      toast.error(err?.response?.data?.message||err?.response?.data?.error||'Try again later')
    })
    .finally(()=>setLoading(false))
  }
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          Process Payment
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="bg-lighter rounded p-3 mb-2">
          {isBulkPayment ? (
            <>
              <div className="d-flex align-items-center mb-3">
                <FaUsers className="text-primary me-2" />
                <h6 className="mb-0">
                  Bulk Payment for {employees?.length} Employees
                </h6>
              </div>
              <div
                className="border rounded p-2 mb-3 scroll-container"
                style={{ maxHeight: "200px", overflowY: "auto" }}
              >
                {employees.map((emp, i) => (
                  <div
                    key={emp?.id}
                    className={`d-flex justify-content-between align-items-center py-2 ${
                      i !== employees?.length - 1 ? "border-bottom" : ""
                    }`}
                  >
                    <div className="d-flex gap-1">
                      <div
                        className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                        style={{
                          width: "37px",
                          height: "37px",
                          fontWeight: 500,
                          fontSize: "0.9rem",
                        }}
                      >
                        <span>{toInitials(emp?.employee_name)}</span>
                      </div>
                      <div>
                        <h6 className="mb-0 text-darker">
                          {emp?.employee_name || "-"}
                        </h6>
                        <small
                          className="text-dark small m-0"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {emp?.employee_email || "-"}
                        </small>
                      </div>
                    </div>
                    <span className="badge bg-secondary">
                      ₹{formatToIndianNumber(emp?.net_salary)}
                    </span>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-between mt-2 fw-medium">
                <span className="text-darker">Total Amount:</span>
                <span className="text-primary">
                  ₹
                  {formatToIndianNumber(
                    employees.reduce(
                      (sum, emp) => sum + Number(emp?.net_salary || 0),
                      0
                    )
                  )}
                </span>
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex gap-1">
                <div
                  className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                  style={{
                    width: "40px",
                    height: "40px",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                  }}
                >
                  <span>{toInitials(employee?.employee_name)}</span>
                </div>
                <div>
                  <h5 className="mb-0 text-darker">
                    {employee?.employee_name || "-"}
                  </h5>
                  <small
                    className="text-dark small m-0"
                    style={{ fontSize: "0.85rem" }}
                  >
                    {employee?.employee_email || "-"}
                  </small>
                </div>
              </div>
              <span className="badge bg-secondary">
                ₹{formatToIndianNumber(employee?.net_salary)}
              </span>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-outline-secondary" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={handlePayment} disabled={loading}>
          {
            loading&&(<Spinner animation="border" size="sm"/>)
          }
          {isBulkPayment
            ? `Pay ${employees.length} Employees`
            : "Process Payment"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModal;
